module.exports = __webpack_public_path__ + "assets/hangli.b37ac896.svg";